<template>
  <div :class="'index' + (isCollapse ? ' collapse' : '')">
    <div class="mask" @click="switchCollapse"></div>
    <aside-page class="aside"></aside-page>
    <div class="main-page">
      <header-page></header-page>
<!--      <tab></tab>-->
      <view-page v-if="isShow"></view-page>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderPage from './HeaderPage';
import AsidePage from './AsidePage';
import ViewPage from './ViewPage'
import {cancelRequestAll} from '@/axios/cancel'
export default {
  name: "index",
  components: {HeaderPage, AsidePage, ViewPage},
  provide(){
    return{
      reload:this.reload
    }
  },
  data() {
    return {
      isShow: true,
    }
  },
  computed: {
    ...mapGetters([
      'isCollapse'
    ])
  },
  methods: {
    switchCollapse() {
      this.$store.commit("switchCollapse");
    },
    reload() {
      cancelRequestAll();
      this.isShow = false;
      this.$nextTick(()=>{this.isShow = true});
    },
  }
}
</script>

<style scoped lang="scss">
.index {
  position: relative;
  height: 100%;
  background: linear-gradient(180deg,#f8fafc,#f1f5f9);
  .mask {
    background: rgba($color: #000000, $alpha: 0.3);
    position: absolute;
    z-index: 90;
    display: none;
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
  }
  .main-page {
    height: 100%;
    margin-left: $aside-width;
    display: flex;
    flex-direction: column;
  }
  &.collapse {
    .main-page {
      margin-left: $aside-width-collapse;
    }
  }
}

@media screen and (max-width: 1050px) {
  .index {
    .mask {
      display: block;
    }
    .main-page {
      margin-left: 0!important;
    }
    &.collapse {
      .aside {
        transform: translate3d(-$aside-width, 0, 0);
      }
      .mask {
        display: none;
      }
    }
  }
}
</style>
